import { useStateManager } from "@bcm-dev/bcms-vite";
import CustomSelect, { CustomSelectItem } from "components/custom-ui/CustomSelect";
import DateSelect from 'components/custom-ui/DateSelect';
import { TableBody, TableView } from 'components/shared';
import { UIAmountInput, UITextInput } from 'components/ui';
import React from 'react';
import { SVGAsset } from "res";

/**
 * @function TASPositivePayAddChecksDesktopView
 * @return {React.Component}
 * @exported true
 * @description The TAS Positive Pay Add Check desktop content view.
 */
export default function TASPositivePayAddChecksDesktopView(props) {
      const { data, ui, onDesktopChange, onDeleteClick, onSubmitClick } = useStateManager();
      const checkForms = data.checkForms;
      const canDeleteCheckForms = checkForms.length > 1;

      const rows = checkForms.reduce((acc, item, index) => {
        const amount = item.amount ? item.amount.amount : undefined;
        
        acc.push(
          <tr key={ item.id } className="table-item-container">
            <td className="table-item-view">
              <DateSelect active={ item.issuedDate.isActive } enablePast={ true }
              value={ item.issuedDate } onChange={ onDesktopChange(item.id, "issuedDate") }
              dataPoint={ `TAS_Positive_Pay_Add_Checks_Desktop_Issued_Date_Input_${ item.id }` } />
            </td>
            <td className="table-item-view">
              <UITextInput value={ item.checkNumber } dataPoint={ `TAS_Positive_Pay_Add_Checks_Desktop_Check_Number_Input_${ item.id }` } 
              onChange={ onDesktopChange(item.id, "checkNumber") } />
            </td>
            <td className="table-item-view">
              <UIAmountInput className="amount-field" value={ amount } dataPoint={ `TAS_Positive_Pay_Add_Checks_Desktop_Amount_Input_${ item.id }` }
              showClearButton={ false }
              onChange={ onDesktopChange(item.id, "amount") } />
            </td>
            <td className="table-item-view">
              <UITextInput value={ item.payee } dataPoint={ `TAS_Positive_Pay_Add_Checks_Desktop_Payee_Input_${ item.id }` }
               onChange={ onDesktopChange(item.id, "payee") } />
            </td>
            <td className="table-item-view">
              <UITextInput value={ item.referenceNumber } dataPoint={ `TAS_Positive_Pay_Add_Checks_Desktop_Reference_Number_Input_${ item.id }` }
               onChange={ onDesktopChange(item.id, "referenceNumber") } />
            </td>
            <td className="table-item-view">
              <CustomSelect active={ item.showTypeDropdown } value={ item.type } dataPoint={ `TAS_Positive_Pay_Add_Checks_Desktop_Type_Select_${ item.id }` }
               onChange={ onDesktopChange(item.id, "type") }>
                  <CustomSelectItem value="issue" dataPoint={ `TAS_Positive_Pay_Add_Checks_Desktop_Option_Issue_${ item.id }` }>Issue</CustomSelectItem>
                  <CustomSelectItem value="stop" dataPoint={ `TAS_Positive_Pay_Add_Checks_Desktop_Option_Stop_${ item.id }` }>Stop</CustomSelectItem>
                  <CustomSelectItem value="void" dataPoint={ `TAS_Positive_Pay_Add_Checks_Desktop_Option_Void_${ item.id }` }>Void</CustomSelectItem>
              </CustomSelect>
            </td>
            { canDeleteCheckForms && 
            <td className="table-item-view">
              <span className="clickable" data-point={ `TAS_Positive_Pay_Add_Checks_Desktop_Close_Button_${ item.id }` } onClick={ onDeleteClick(item.id) }>
                <SVGAsset id="cancel" />
              </span>
            </td> 
            }
          </tr>
        );
        return acc;
      }, []);

    return (
        <div className="flex-container table-view-container show-on-desktop">
        <TableView className="tas-positive-pay-add-check-table">
            <thead className="table-column-container">
            <tr>
                <th className="text-left table-column-view">Issued Date</th>
                <th className="text-left table-column-view">Check Number</th>
                <th className="text-left table-column-view">Amount</th>
                <th className="text-left table-column-view">Payee (Optional)</th>
                <th className="text-left table-column-view">Reference Number (Optional)</th>
                <th className="text-left table-column-view">Type</th>
                { canDeleteCheckForms && <th className="text-left table-column-view"></th> }
            </tr>
            </thead>
            <TableBody>{ rows } </TableBody>
        </TableView>
        </div>
    );
}